module.exports = __webpack_public_path__ + "static/RoadmapBot2-52f5ca78d3db1baa34b01530eb67409e.png";